import HTTPResponseEntity  from '@/js/Shared/Services/HTTP/Entities/HTTPResponseEntity.js';
import AccountSendersItem  from '../Entities/AccountSendersItem.js';

export { AntiSpamHTTPMapping as default };

/**
* Identities HTTP Mapping
*
* @author      rsommerfeld <roni.s.sommerfeld@altice.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class AntiSpamHTTPMapping
{
    /**
     * Resets an entire Account Senders Data list and maps new items from server response
     *
     * @public
     *
     * @since 7.0.0
     *
     * @param {AccountSendersData} data     Account Senders data item
     * @param {HTTPResponseEntity} response http response entity
     *
     * @return {void}
     */
    mapWhitelistList(data, response) {
        if (!response.results) {
            return;
        }

        data.whitelist.reset();

        response.results.forEach((item) => {
            data.whitelist.add(this.mapWhitelistItem(item))
        });

         data.whitelist.resortItems();

    }

    /**
     * Adds item to an Account Senders Data
     *
     * @public
     *
     * @since 7.0.0
     *
     * @param {AccountSendersData} data     Account Senders data item
     * @param {HTTPResponseEntity} response http response entity
     *
     * @return {void}
     */
    mapWhitelistAddItem(data, response) {
        if (!response.results) {
            return;
        }

        response.results.forEach((result_item) => {
            let item = this.mapWhitelistItem(result_item);
            data.whitelist.add(item);
        });

        data.whitelist.resortItems();
    }

    /**
     * Removes item from an Account Senders Data
     *
     * @public
     *
     * @since 7.0.0
     *
     * @param {AccountSendersData} data     Account Senders data item
     * @param {HTTPResponseEntity} response http response entity
     *
     * @return {void}
     */
    mapWhitelistRemoveItem(data, response) {
        if (!response.results) {
            return;
        }

        data.whitelist.delete(response.results.sender);
        data.whitelist.resortItems();
    }

    /**
     * Map the values for Whitelist
     *
     * @public
     *
     * @since 7.0.0
     *
     * @param {Object} result_item item from server response
     *
     * @return {WhitelistItem}
     */
    mapWhitelistItem(result_item){
        let item    = new AccountSendersItem;
        item.sender = result_item.sender;
        item.status = result_item.status;
        item.type   = result_item.type;
        item.rule   = result_item.sender.startsWith('@') ? 'domain' : 'address';

        return item;
    }

    /**
     * Resets an entire Account Senders Data list and maps new items from server response
     *
     * @public
     *
     * @since 7.0.0
     *
     * @param {AccountSendersData} data     Account Senders data item
     * @param {HTTPResponseEntity} response http response entity
     *
     * @return {void}
     */
    mapBlacklistList(data, response) {
        if (!response.results) {
            return;
        }

        data.blacklist.reset();

        response.results.forEach((item) => {
            data.blacklist.add(this.mapBlacklistItem(item))
        });


        data.blacklist.resortItems();
    }

    /**
     * Adds item to an Account Senders Data
     *
     * @public
     *
     * @since 7.0.0
     *
     * @param {AccountSendersData} data     Account Senders data item
     * @param {HTTPResponseEntity} response http response entity
     *
     * @return {void}
     */
    mapBlacklistAddItem(data, response) {
        if (!response.results) {
            return;
        }

        response.results.forEach((result_item) => {
            let item = this.mapBlacklistItem(result_item);
            data.blacklist.add(item);
        });

        data.blacklist.resortItems();
    }

    /**
     * Removes item from an Account Senders Data
     *
     * @public
     *
     * @since 7.0.0
     *
     * @param {AccountSendersData} data     Account Senders data item
     * @param {HTTPResponseEntity} response http response entity
     *
     * @return {void}
     */
    mapBlacklistRemoveItem(data, response) {
        if (!response.results) {
            return;
        }

        data.blacklist.delete(response.results.sender);
        data.blacklist.resortItems();
    }

    /**
     * Map the values for Blacklist
     *
     * @public
     *
     * @since 7.0.0
     *
     * @param {Object} result_item item from server response
     *
     * @return {BlacklistItem}
     */
    mapBlacklistItem(result_item){
        let item    = new AccountSendersItem;
        item.sender = result_item.sender;
        item.status = result_item.status;
        item.type   = result_item.type;
        item.rule   = result_item.sender.startsWith('@') ? 'domain' : 'address';

        return item;
    }
}